import { MismatchquestionsinsubmitComponent } from './mismatchquestionsinsubmit/mismatchquestionsinsubmit.component';
import { ViewtickethistoryComponent } from './viewtickethistory/viewtickethistory.component';
import { ViewticketnotesComponent } from './viewticketnotes/viewticketnotes.component';
import { TicketNotes, TicketHistory } from './../shared/ticket';
import { forEach } from '@angular/router/src/utils/collection';
import { SendFeedBack, ParseJsonQuestion, QATicketNotes, RolesForSendingFeedback } from './../shared/qaTicket';
import { SendfeedbackComponent } from './../dialogs/sendfeedback/sendfeedback.component';
import { AuthGuardService } from "./../shared/auth-guard.service";
import { QualityTicketService } from "./../shared/qualityticketqueue.service";
import { Component, Inject, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OnInit } from "@angular/core/src/metadata/lifecycle_hooks";
import { User } from "../shared/User";
import { UserService } from "../shared/userService";
import { LocalStorage } from "../shared/localstorage.service";
import { TicketService } from "../shared/ticketService";
import { Ticket, TicketCode } from "../shared/ticket";
import { QuestionService } from "../shared/questionService";
import { QATicket, QAResponse, Question } from "../shared/qaTicket";
import { NgForm } from "@angular/forms/src/directives/ng_form";
import { InnerSubscriber } from "rxjs/InnerSubscriber";
import { AuthenticationService } from "./../shared/authentication.service";
import { timeout } from "q";
import { isNullOrUndefined } from "util";
import { MatDialog } from '@angular/material';
import { NewWorkArea } from '../shared/map.model';
import { InfodialogComponent } from '../dialogs/infodialog/infodialog.component';
import { Logger } from '../shared/logger.service';
import { tokenKey } from '../../../../node_modules/@angular/core/src/view';
import { AddqualitynotesComponent } from './addqualitynotes/addqualitynotes.component';

@Component({
    templateUrl: "./ticket.component.html",
    styleUrls: ["./ticket.component.scss"]
})
export class TicketComponent implements OnInit {
    public pageTitle = "QA Ticket";
    gcLoading = false;
    qaLoading = false;
    ticket: Ticket;
    qaTicket = new QATicket();
    sendFeedBackObj = new SendFeedBack();
    excavator = new Array<QAResponse>();
    notification = new Array<QAResponse>();
    location = new Array<QAResponse>();
    remarks = new Array<QAResponse>();
    map = new Array<QAResponse>();
    end = new Array<QAResponse>();
    qaStart: string;
    qaGeom: string = '';
    qaGeomCodes: TicketCode[];
    submitted = false;
    screen = false;
    showTicketCodes = false;
    afterSave = "";
    newTicketGenerated: string;
    submitError = "";
    correctionType = "";
    correctedTicket = false;
    sendFeedback = false;
    questionsParsedInJson: ParseJsonQuestion[];
    canPush = false;
    showGoogle = false;
    ticketNotes = new TicketNotes();
    ticketHistory: TicketHistory[];
    questionCheckOnSubmit: true;
    mismatchQuestions = new Array<QAResponse>();
    gpsPoints = [];
    gpsMethod = {};
    positiveResponse;
    informationHeaderText: string;

    constructor(private ticketService: TicketService,
        private questionService: QuestionService,
        private localStorage: LocalStorage,
        private router: Router,
        private qualityTicketService: QualityTicketService,
        private authService: AuthenticationService,
        private queueService: QualityTicketService,
        route: ActivatedRoute,
        private _router: Router,
        public dialog: MatDialog,
        public logger: Logger) {
        this.qaTicket.GCTicketNumber = route.snapshot.params["number"];
    }
    ngOnInit(): void {
        this.gcLoading = true;
        this.qaStart = new Date().toLocaleString("en-US", { timeZone: "America/Chicago" });
        if (this.qaTicket.GCTicketNumber === "nextexternal") {
            this.afterSave = "getNextExternal";
            this.queueService.getOldTicket(this.authService.username, 'external', this.authService.currentState).then(res => {
                if (!isNullOrUndefined(res)) {
                    this.qaTicket.GCTicketNumber = res.GCTicketNumber.toString();
                    this.qaTicket.QATicketNotes = new QATicketNotes();
                    this.ticketService.getTicket(this.qaTicket.GCTicketNumber, this.localStorage.getItem("token"), this.authService.currentState).then(ticket => {
                        this.ticket = ticket;
                        this.qaTicket.PacketID = this.ticket.packetId;
                        this.parseJsonTicketCustomAttributes();
                        this.questionService.getActive(this.authService.currentState).then(questions => {
                            const ticketQuestions = new Array<QAResponse>();
                            questions.forEach(question => {
                                if (question.QueueCategory.toLowerCase() !== "all") {
                                    if (question.QueueCategory.toLowerCase() === res.QueueCategory.toLowerCase()) {
                                        const response = new QAResponse();
                                        if (question.CustomResponse !== null && question.CustomResponse !== '') {
                                            const possbileanswers = JSON.parse(question.CustomResponse).possibleanswers;
                                            const criticalvalues = JSON.parse(question.CustomResponse).criticallevel;

                                            response.AnswerValues = possbileanswers[0].split(",");
                                            response.CriticalLevelValues = criticalvalues[0].split(",");
                                        }
                                        response.QuestionID = question.ID;
                                        response.QuestionText = question.QuestionText;
                                        response.Section = question.Section;
                                        response.CanNA = question.CanNA;
                                        response.CriticalLevel = question.CriticalLevel;
                                        response.ValidResponse = question.ValidResponse;
                                        if (!(question.Condition === null || question.Condition === "")) {
                                            this.canPush = false;
                                            this.questionsParsedInJson = JSON.parse(question.Condition);

                                            for (let i = 0; i < this.questionsParsedInJson.length; i++) {
                                                if (this.questionsParsedInJson[i].attribute === "ticketType") {
                                                    if (this.questionsParsedInJson[i].value.indexOf(this.ticket.ticketType) !== -1) {
                                                        this.canPush = true;
                                                    }
                                                    else {
                                                        this.canPush = false;
                                                        break;
                                                    }
                                                }
                                                if (this.questionsParsedInJson[i].attribute === "source") {
                                                    if (this.questionsParsedInJson[i].value.indexOf(this.ticket.source) !== -1) {
                                                        this.canPush = true;
                                                    }
                                                    else {
                                                        this.canPush = false;
                                                        break;
                                                    }
                                                }
                                            }
                                            if (this.canPush) {
                                                ticketQuestions.push(response);
                                            }
                                        } else {
                                            ticketQuestions.push(response);
                                        }
                                    }
                                }
                                else {
                                    const response = new QAResponse();

                                    if (question.CustomResponse !== null && question.CustomResponse !== '') {
                                        const possbileanswers = JSON.parse(question.CustomResponse).possibleanswers;
                                        const criticalvalues = JSON.parse(question.CustomResponse).criticallevel;

                                        response.AnswerValues = possbileanswers[0].split(",");
                                        response.CriticalLevelValues = criticalvalues[0].split(",");
                                    }
                                    response.QuestionID = question.ID;
                                    response.QuestionText = question.QuestionText;
                                    response.Section = question.Section;
                                    response.CanNA = question.CanNA;
                                    response.CriticalLevel = question.CriticalLevel;
                                    response.ValidResponse = question.ValidResponse;
                                    if (!(question.Condition === null || question.Condition === "")) {
                                        this.canPush = false;
                                        this.questionsParsedInJson = JSON.parse(question.Condition);

                                        for (let i = 0; i < this.questionsParsedInJson.length; i++) {
                                            if (this.questionsParsedInJson[i].attribute === "ticketType") {
                                                if (this.questionsParsedInJson[i].value.indexOf(this.ticket.ticketType) !== -1) {
                                                    this.canPush = true;
                                                }
                                                else {
                                                    this.canPush = false;
                                                    break;
                                                }
                                            }
                                            if (this.questionsParsedInJson[i].attribute === "source") {
                                                if (this.questionsParsedInJson[i].value.indexOf(this.ticket.source) !== -1) {
                                                    this.canPush = true;
                                                }
                                                else {
                                                    this.canPush = false;
                                                    break;
                                                }
                                            }
                                        }
                                        if (this.canPush) {
                                            ticketQuestions.push(response);
                                        }
                                    } else {
                                        ticketQuestions.push(response);
                                    }
                                }
                            });
                            this.excavator = ticketQuestions.filter(x => x.Section === 0);
                            this.notification = ticketQuestions.filter(x => x.Section === 1);
                            this.location = ticketQuestions.filter(x => x.Section === 2);
                            this.remarks = ticketQuestions.filter(x => x.Section === 3);
                            this.map = ticketQuestions.filter(x => x.Section === 4);
                            this.end = ticketQuestions.filter(x => x.Section === 5);
                        });
                        this.gcLoading = false;
                    });
                } else {
                    this.ticket = new Ticket();
                    let infoalert = this.dialog.open(InfodialogComponent, {
                        width: '500px',
                        data: {
                          title: 'Alert',
                          content: 'It appears that you are not assigned to this queue. Please contact the department manager for assistance.'
                        }
                      });
                      this.gcLoading = false;
                }

            });
        } else if (this.qaTicket.GCTicketNumber === "nextinternal") {
            this.afterSave = "getNextInternal";
            this.queueService.getOldTicket(this.authService.username, 'internal', this.authService.currentState).then(res => {
                if (!isNullOrUndefined(res)) {
                    this.qaTicket.GCTicketNumber = res.GCTicketNumber.toString();
                    this.qaTicket.QATicketNotes = new QATicketNotes();
                    this.ticketService.getTicket(this.qaTicket.GCTicketNumber, this.localStorage.getItem("token"), this.authService.currentState).then(ticket => {
                        this.ticket = ticket;
                        this.qaTicket.PacketID = this.ticket.packetId;
                        this.parseJsonTicketCustomAttributes();
                        this.questionService.getActive(this.authService.currentState).then(questions => {
                            const ticketQuestions = new Array<QAResponse>();
                            questions.forEach(question => {
                                if (question.QueueCategory.toLowerCase() !== 'all') {
                                    if (question.QueueCategory.toLowerCase() === res.QueueCategory.toLowerCase()) {
                                        const response = new QAResponse();

                                        if (question.CustomResponse !== null && question.CustomResponse !== '') {
                                            const possbileanswers = JSON.parse(question.CustomResponse).possibleanswers;
                                            const criticalvalues = JSON.parse(question.CustomResponse).criticallevel;

                                            response.AnswerValues = possbileanswers[0].split(",");
                                            response.CriticalLevelValues = criticalvalues[0].split(",");
                                        }
                                        response.QuestionID = question.ID;
                                        response.QuestionText = question.QuestionText;
                                        response.Section = question.Section;
                                        response.CanNA = question.CanNA;
                                        response.CriticalLevel = question.CriticalLevel;
                                        response.ValidResponse = question.ValidResponse;
                                        if (!(question.Condition === null || question.Condition === "")) {
                                            this.canPush = false;
                                            this.questionsParsedInJson = JSON.parse(question.Condition);

                                            for (let i = 0; i < this.questionsParsedInJson.length; i++) {
                                                if (this.questionsParsedInJson[i].attribute === "ticketType") {
                                                    if (this.questionsParsedInJson[i].value.indexOf(this.ticket.ticketType) !== -1) {
                                                        this.canPush = true;
                                                    }
                                                    else {
                                                        this.canPush = false;
                                                        break;
                                                    }
                                                }
                                                if (this.questionsParsedInJson[i].attribute === "source") {
                                                    if (this.questionsParsedInJson[i].value.indexOf(this.ticket.source) !== -1) {
                                                        this.canPush = true;
                                                    }
                                                    else {
                                                        this.canPush = false;
                                                        break;
                                                    }
                                                }
                                            }
                                            if (this.canPush) {
                                                ticketQuestions.push(response);
                                            }
                                        } else {
                                            ticketQuestions.push(response);
                                        }
                                    }
                                } else {
                                    const response = new QAResponse();



                                    if (question.CustomResponse !== null && question.CustomResponse !== '') {
                                        const possbileanswers = JSON.parse(question.CustomResponse).possibleanswers;
                                        const criticalvalues = JSON.parse(question.CustomResponse).criticallevel;

                                        response.AnswerValues = possbileanswers[0].split(",");
                                        response.CriticalLevelValues = criticalvalues[0].split(",");
                                    }
                                    response.QuestionID = question.ID;
                                    response.QuestionText = question.QuestionText;
                                    response.Section = question.Section;
                                    response.CanNA = question.CanNA;
                                    response.CriticalLevel = question.CriticalLevel;
                                    response.ValidResponse = question.ValidResponse;
                                    if (!(question.Condition === null || question.Condition === "")) {
                                        this.canPush = false;
                                        this.questionsParsedInJson = JSON.parse(question.Condition);

                                        for (let i = 0; i < this.questionsParsedInJson.length; i++) {
                                            if (this.questionsParsedInJson[i].attribute === "ticketType") {
                                                if (this.questionsParsedInJson[i].value.indexOf(this.ticket.ticketType) !== -1) {
                                                    this.canPush = true;
                                                }
                                                else {
                                                    this.canPush = false;
                                                    break;
                                                }
                                            }
                                            if (this.questionsParsedInJson[i].attribute === "source") {
                                                if (this.questionsParsedInJson[i].value.indexOf(this.ticket.source) !== -1) {
                                                    this.canPush = true;
                                                }
                                                else {
                                                    this.canPush = false;
                                                    break;
                                                }
                                            }
                                        }
                                        if (this.canPush) {
                                            ticketQuestions.push(response);
                                        }
                                    } else {
                                        ticketQuestions.push(response);
                                    }
                                }
                            });
                            this.excavator = ticketQuestions.filter(x => x.Section === 0);
                            this.notification = ticketQuestions.filter(x => x.Section === 1);
                            this.location = ticketQuestions.filter(x => x.Section === 2);
                            this.remarks = ticketQuestions.filter(x => x.Section === 3);
                            this.map = ticketQuestions.filter(x => x.Section === 4);
                            this.end = ticketQuestions.filter(x => x.Section === 5);
                        });
                        this.gcLoading = false;
                    });
                } else {
                    this.ticket = new Ticket();
                    let infoalert = this.dialog.open(InfodialogComponent, {
                        width: '500px',
                        data: {
                          title: 'Alert',
                          content: 'It appears that you are not assigned to this queue. Please contact the department manager for assistance.'
                        }
                      });
                      this.gcLoading = false;
                }

            });
        } else {
            this.afterSave = "queue";
            this.ticketService.getTicket(this.qaTicket.GCTicketNumber, this.localStorage.getItem("token"), this.authService.currentState).then(ticket => {
                this.ticket = ticket;
                this.qaTicket.PacketID = this.ticket.packetId;
                this.parseJsonTicketCustomAttributes();
                this.qaTicket.QATicketNotes = new QATicketNotes();
                this.questionService.getActive(this.authService.currentState).then(questions => {
                    const ticketQuestions = new Array<QAResponse>();
                    questions.forEach(question => {
                        if (question.QueueCategory.toLowerCase() !== 'all') {
                            if (question.QueueCategory.toLowerCase() === ticket.queueCategory.toLowerCase()) {
                                const response = new QAResponse();

                                if (question.CustomResponse !== null && question.CustomResponse !== '') {
                                    const possbileanswers = JSON.parse(question.CustomResponse).possibleanswers;
                                    const criticalvalues = JSON.parse(question.CustomResponse).criticallevel;

                                    response.AnswerValues = possbileanswers[0].split(",");
                                    response.CriticalLevelValues = criticalvalues[0].split(",");
                                }
                                response.QuestionID = question.ID;
                                response.QuestionText = question.QuestionText;
                                response.Section = question.Section;
                                response.CanNA = question.CanNA;
                                response.CriticalLevel = question.CriticalLevel;
                                response.ValidResponse = question.ValidResponse;
                                if (!(question.Condition === null || question.Condition === "")) {
                                    this.canPush = false;
                                    this.questionsParsedInJson = JSON.parse(question.Condition);

                                    for (let i = 0; i < this.questionsParsedInJson.length; i++) {
                                        if (this.questionsParsedInJson[i].attribute === "ticketType") {
                                            if (this.questionsParsedInJson[i].value.indexOf(this.ticket.ticketType) !== -1) {
                                                this.canPush = true;
                                            }
                                            else {
                                                this.canPush = false;
                                                break;
                                            }
                                        }
                                        if (this.questionsParsedInJson[i].attribute === "source") {
                                            if (this.questionsParsedInJson[i].value.indexOf(this.ticket.source) !== -1) {
                                                this.canPush = true;
                                            }
                                            else {
                                                this.canPush = false;
                                                break;
                                            }
                                        }
                                    }
                                    if (this.canPush) {
                                        ticketQuestions.push(response);
                                    }
                                } else {
                                    ticketQuestions.push(response);
                                }
                            }
                        }
                        else {
                            const response = new QAResponse();
                            this.qaTicket.QATicketNotes = new QATicketNotes();
                            if (question.CustomResponse !== null && question.CustomResponse !== '') {
                                const possbileanswers = JSON.parse(question.CustomResponse).possibleanswers;
                                const criticalvalues = JSON.parse(question.CustomResponse).criticallevel;

                                response.AnswerValues = possbileanswers[0].split(",");
                                response.CriticalLevelValues = criticalvalues[0].split(",");
                            }
                            response.QuestionID = question.ID;
                            response.QuestionText = question.QuestionText;
                            response.Section = question.Section;
                            response.CanNA = question.CanNA;
                            response.CriticalLevel = question.CriticalLevel;
                            response.ValidResponse = question.ValidResponse;
                            if (!(question.Condition === null || question.Condition === "")) {
                                this.canPush = false;
                                this.questionsParsedInJson = JSON.parse(question.Condition);

                                for (let i = 0; i < this.questionsParsedInJson.length; i++) {
                                    if (this.questionsParsedInJson[i].attribute === "ticketType") {
                                        if (this.questionsParsedInJson[i].value.indexOf(this.ticket.ticketType) !== -1) {
                                            this.canPush = true;
                                        }
                                        else {
                                            this.canPush = false;
                                            break;
                                        }
                                    }
                                    if (this.questionsParsedInJson[i].attribute === "source") {
                                        if (this.questionsParsedInJson[i].value.indexOf(this.ticket.source) !== -1) {
                                            this.canPush = true;
                                        }
                                        else {
                                            this.canPush = false;
                                            break;
                                        }
                                    }
                                }
                                if (this.canPush) {
                                    ticketQuestions.push(response);
                                }
                            } else {
                                ticketQuestions.push(response);
                            }
                        }
                    });
                    this.excavator = ticketQuestions.filter(x => x.Section === 0);
                    this.notification = ticketQuestions.filter(x => x.Section === 1);
                    this.location = ticketQuestions.filter(x => x.Section === 2);
                    this.remarks = ticketQuestions.filter(x => x.Section === 3);
                    this.map = ticketQuestions.filter(x => x.Section === 4);
                    this.end = ticketQuestions.filter(x => x.Section === 5);
                });
                this.gcLoading = false;
            });
        }
    }

    parseJsonTicketCustomAttributes() {
        this.gpsPoints = this.ticket.gps       ? JSON.parse(this.ticket.gps)       : [];
        this.gpsMethod = this.ticket.gpsMethod ? JSON.parse(this.ticket.gpsMethod) : {};
        if (this.ticket.positiveResponse) this.positiveResponse = JSON.parse(this.ticket.positiveResponse);

        if (this.ticket.informationHeader) {
            var IH = JSON.parse(this.ticket.informationHeader);
            var IHStrings = [];
            var lineStatusSentence;

            if (IH.lineCondition && IH.lineType) {
                var capitalizeFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

                lineStatusSentence = capitalizeFirstLetter(IH.lineCondition) + " " + capitalizeFirstLetter(IH.lineType) + " Line"

                if (IH.lineType == 'unknown' && !IH.lineDescription) {
                    lineStatusSentence += " - Line described as " + IH.lineDescription;
                }
            }

            if (IH.previousTicketNumber) IHStrings.push(IH.previousTicketNumber);
            if (lineStatusSentence)      IHStrings.push(lineStatusSentence);
            if (IH.crewStatus)           IHStrings.push(IH.crewStatus);
            if (IH.customerStatus)       IHStrings.push(IH.customerStatus);
            if (IH.additionalDetails)    IHStrings.push(IH.additionalDetails);
            if (IH.markingsVisible)      IHStrings.push(IH.markingsVisible);
            if (IH.damagedBy)            IHStrings.push("Damaged by: " + IH.damagedBy);
            if (IH.damagedWith)          IHStrings.push("Damaged with: " + IH.damagedWith);

            this.informationHeaderText = IH.ticketType + "-" + IHStrings.join(', ')
        }
    }

    onSubmit(action: string): void {
        this.mismatchQuestions = new Array<QAResponse>();
        this.qaTicket.Response = this.excavator
            .concat(this.notification)
            .concat(this.location)
            .concat(this.remarks)
            .concat(this.map)
            .concat(this.end);

        const feedback = new Array<string>(
            this.qaTicket.ExcavatorFeedback,
            this.qaTicket.NotificationFeedback,
            this.qaTicket.LocationFeedback,
            this.qaTicket.RemarksFeedback,
            this.qaTicket.MappingFeedback,
            this.qaTicket.EndFeedback
        );

        this.qaTicket.Response.forEach(response => {
            
            if (response.ResponseValue !== 'na') {
                if (response.ResponseValue !== response.ValidResponse) {
                    this.mismatchQuestions.push(response);
                }
            }
        });

        if (this.mismatchQuestions.length > 0) {
            let mismatchquestionsdialog = this.dialog.open(MismatchquestionsinsubmitComponent, {
                width: '600px',
                data: {
                    questions: this.mismatchQuestions,
                    submit: true
                }
              });
              mismatchquestionsdialog.afterClosed().subscribe(result => {
                  
                if (result === 'ok') {
                    this.qaTicket.GCTicketCorrection = this.correctionType;
                    this.screen = true;
                    this.questionService.saveQATicket(
                        this.qaTicket.GCTicketNumber, feedback, this.localStorage.getItem("userName"), this.qaStart,
                        this.qaTicket.Response, this.qaTicket.GCTicketCorrection, this.qaGeom, this.qaGeomCodes,
                        this.ticket.takenBy, this.ticket.queueCategory, this.qaTicket.QATicketNotes, this.qaTicket.PacketID, this.qaTicket.GCTicketID, this.authService.currentState, this.authService.token)
                        .then(res => {
                            if (res !== "An error occured.") {
                                if (action === "submit") {
                                    if (this.afterSave === "getNextExternal" || this.afterSave === "getNextInternal") {
                                        this.router.navigate(["/qualityticket"]);
                                    } else if (this.afterSave === "queue") {
                                        this.router.navigate(["/qualityticketqueue/normal"]);
                                    }
                                } else if (action === "next") {
                                    if (this.afterSave === 'queue') {
                                        this.router.navigate(["/qualityticketqueue/normal"]);
                                        location.reload();
                                    } else if (this.afterSave === 'getNextExternal') {
                                        this.router.navigate(["/ticket/nextexternal"]);
                                        location.reload();
                                    } else if (this.afterSave === 'getNextInternal') {
                                        this.router.navigate(["/ticket/nextinternal"]);
                                        location.reload();
                                    } else {
                                        location.reload();
                                    }
                                }
                            }
                            this.screen = false;
                        });
                }
                else {
                    return;
                }
              });
        } else {
            this.qaTicket.GCTicketCorrection = this.correctionType;
            this.screen = true;
            this.questionService.saveQATicket(
                this.qaTicket.GCTicketNumber, feedback, this.localStorage.getItem("userName"), this.qaStart,
                this.qaTicket.Response, this.qaTicket.GCTicketCorrection, this.qaGeom, this.qaGeomCodes,
                this.ticket.takenBy, this.ticket.queueCategory, this.qaTicket.QATicketNotes, this.qaTicket.PacketID, this.qaTicket.GCTicketID, this.authService.currentState, this.authService.token)
                .then(res => {
                    if (res !== "An error occured.") {
                        if (action === "submit") {
                            if (this.afterSave === "getNextExternal" || this.afterSave === "getNextInternal") {
                                this.router.navigate(["/qualityticket"]);
                            } else if (this.afterSave === "queue") {
                                this.router.navigate(["/qualityticketqueue/normal"]);
                            }
                        } else if (action === "next") {
                            if (this.afterSave === 'queue') {
                                this.router.navigate(["/qualityticketqueue/normal"]);
                                location.reload();
                            } else if (this.afterSave === 'getNextExternal') {
                                this.router.navigate(["/ticket/nextexternal"]);
                                location.reload();
                            } else if (this.afterSave === 'getNextInternal') {
                                this.router.navigate(["/ticket/nextinternal"]);
                                location.reload();
                            } else {
                                location.reload();
                            }
                        }
                    }
                    this.screen = false;
                });
            }
    }

    deferClick() {

        this.qualityTicketService.deferTicket(this.authService.username, this.ticket.number, this.authService.currentState).subscribe(res => {
            this.router.navigate(["qualityticket"]);
        });
    }

    ToggleTicketCodes() {
        if (this.showTicketCodes) {
            this.showTicketCodes = false;
        } else {
            this.showTicketCodes = true;
        }
    }
    focusError() {
        this.submitted = true;
        this.submitError = "Please verify all required fields have been filled out.";
        const errors = document.querySelectorAll("mat-radio-group.ng-invalid");
        if (errors.length > 0) {
            errors[0].parentElement.scrollIntoView();
        }
    }

    getmap() {
        this._router.navigate(["/mapcontainer"]);
    }

    clearCorrectionType() {
        this.correctionType = "";
    }

    @Input()
    onWorkAreaChange(workArea: NewWorkArea) {
        this.qaGeom = workArea.geom;
        this.qaGeomCodes = workArea.codes;
    }

    OnAnswerClick(ansResp: QAResponse, answerValue: string) {
        for (let i = 0; i < ansResp.AnswerValues.length; i++) {
            if (ansResp.AnswerValues[i].toLowerCase() === answerValue.toLowerCase()) {
                ansResp.CriticalLevel = ansResp.CriticalLevelValues[i];
            }
        }
    }
    getTicketNumber() {
        this.logger.userLog(this.localStorage.getItem("username"), "Get ticketnumber " + this.ticket.number);
        let infoDialogTicketNumber = this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
                title: 'Ticket Number',
                content: this.ticket.number
            }
        });
    }

    getGeoCallTicketNotes() {
        this.questionService.getTicketNotes(this.localStorage.getItem("token"), this.ticket.ticketId, this.authService.currentState).subscribe(res => {
            this.ticketNotes = res;
            if (!isNullOrUndefined(this.ticketNotes.itemNote)) {
                let ticketNotesDialog = this.dialog.open(ViewticketnotesComponent, {
                    width: '500px',
                    data: this.ticketNotes
                });
            } else {
                let infoDialog = this.dialog.open(InfodialogComponent, {
                    width: '500px',
                    data: {
                        title: 'Ticket Notes',
                        content: 'Ticket Notes not found.'
                    }
                });
            }
        });

    }

    getGeoCallTicketHistory() {
        this.logger.userLog(this.localStorage.getItem("username"), "Get Ticket History " + this.ticket.number);
        this.screen = true;
        this.questionService.getTicketHistory(this.localStorage.getItem("token"),
            this.ticket.ticketId, this.ticket.number, this.ticket.takenBy,
            this.ticket.ticketType, this.ticket.creation, this.authService.currentState).subscribe(res => {
                this.ticketHistory = res.reverse();
                let ticketHistoryDialog = this.dialog.open(ViewtickethistoryComponent, {
                    width: '800px',
                    data: this.ticketHistory
                });
                this.screen = false;
            });
    }

    addQualityNotes() {
        let qualityNotesDialog;
        if (isNullOrUndefined(this.qaTicket.QATicketNotes)) {
            qualityNotesDialog = this.dialog.open(AddqualitynotesComponent, {
                width: '500px'
            });
        }
        else {
            qualityNotesDialog = this.dialog.open(AddqualitynotesComponent, {
                width: '500px',
                data: {
                    subject: this.qaTicket.QATicketNotes.Subject,
                    message: this.qaTicket.QATicketNotes.Message,
                    IsEvaluate: false,
                    IsDispute: false
                }
            });
        }

        qualityNotesDialog.afterClosed().subscribe(result => {
            if (result === 'cancel') {
                return;
            }
            if (result !== 'cancel') {
                this.qaTicket.QATicketNotes.Subject = result.subject;
                this.qaTicket.QATicketNotes.Message = result.message;
                this.qaTicket.QATicketNotes.CreatedBy = this.localStorage.getItem("username");
            }
        });
    }

    ShowGoogle(){
        this.showGoogle = !this.showGoogle;
    }
}

